const removeSpecialCharacters = (value: string) => value.replace(/[^a-zA-Z0-9]/g, '');
const bannerWordsRefine =
  (
    bannedWords: string[],
    softWords: string[] = [],
    { cleanValue = true }: { cleanValue?: boolean } = {}
  ) =>
  (value) => {
    if (typeof value !== 'string') return true;

    if (softWords.some((word) => value.toLowerCase().includes(word.toLowerCase()))) {
      return !softWords.some((word) => {
        const cleanedWord = removeSpecialCharacters(value.toLowerCase());
        const regex = new RegExp(`\\b${cleanedWord}\\b`);
        return regex.test(word);
      });
    }

    if (cleanValue)
      return !bannedWords.some((word) =>
        removeSpecialCharacters(value.toLowerCase()).includes(
          removeSpecialCharacters(word.toLowerCase())
        )
      );

    return !bannedWords.some((word) => value.toLowerCase().includes(word.toLowerCase()));
  };

export default bannerWordsRefine;
